import { getGeolocation } from "./getGeolocation";

const geolocationApi = {
    getGeolocation
}

export default geolocationApi;
